import { render } from "./SelectControl.vue?vue&type=template&id=c6a98442"
import script from "./SelectControl.vue?vue&type=script&lang=js"
export * from "./SelectControl.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SelectControl.vue"]])

export default __exports__